// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ABs7","file":"styles_file__CstPL"};